// extracted by mini-css-extract-plugin
export default {"listaOpciones":"ListaOpciones_listaOpciones__4O3to","select":"ListaOpciones_select__7KDT-"};